import { 
    Dialog as DialogMaterial, DialogActions, DialogContent, 
    DialogContentText, DialogTitle, Button, Backdrop
 } from '@material-ui/core';

const Dialog = (props) => {
    return (
        <DialogMaterial 
            autofocus 
            open={props.visible} 
            aria-labelledby="responsive-dialog-title"
            hideBackdrop
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            >
            <DialogTitle id="responsive-dialog-title">{props.title}</DialogTitle>
            <DialogContent>                
                { props.renderAsHtml && (<div dangerouslySetInnerHTML={{ __html: props.contenttext }} />)} 
                { props.contenttext && (<DialogContentText>{ props.contenttext }</DialogContentText>)}
                { props.children }
            </DialogContent>
            <DialogActions>
                {
                    props.buttons.map( (buttons, index) => {
                        return (
                            <Button style={{...buttons.style}} disabled={buttons.disabled} color={buttons.color} onClick={() => buttons.onClick()} key={index}>
                                {buttons.icon}&nbsp;{buttons.title}
                            </Button>
                        )
                    })
                }
            </DialogActions>
        </DialogMaterial>
    )
}

export default Dialog;